import React from "react";
import Layout from "../components/layout";
import { LoadingSpinner } from "../components/ui";
import { useAuth } from "../hooks/useAuth";
import Dashboard from "../components/dashboard/Dashboard";

const siteMetadata = {
  title: "Designing Multi-Agent Systems",
  description:
    "Access your book downloads, manage your account, and explore exclusive content for Designing Multi-Agent Systems",
  author: "Victor Dibia",
  image: "/images/og-service.png",
  keywords: "multi-agent, customer platform, dashboard, payments",
  twitterUsername: "@designingwithml",
};

const IndexPage: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  return (
    <Layout meta={siteMetadata} title="Buy the Multi-Agent Book" link={"/"}>
      <main className="container mx-auto bg-primary">
        {isLoading ? (
          <div className="flex items-center justify-center min-h-[400px]">
            <LoadingSpinner size="lg" text="Loading your dashboard..." />
          </div>
        ) : (
          <Dashboard user={isAuthenticated && user ? user : null} />
        )}
      </main>
    </Layout>
  );
};

export default IndexPage;
